<app-status-message *ngIf="activateStatusMessage" [statusMessageType]="statusMessageType" id="statusMessageComp"
    [editMoreAvailable]="editMoreAvailable" (openLayerEditEE)="openLayerEdit($event)"
    (sendDeleteOptionsEE)="handleDeleteRequest($event)" [layerToDelete]="layerNameForDeletion">

</app-status-message>

<div #loadingLogoContainer [hidden]="loadingLogoIsHidden"> <!-- *ngIf = "loadingLogoIsHidden" -->

</div>

<div id=addLayerWrapper *ngIf="activateStatusMessage === false && loadingLogoIsHidden === true">
    <button mat-raised-button id="closeButton" class="btnHoover" (click)="handleClosing()">X</button>
    <div class="megaGrid">

        <section *ngIf="showLayerPicker" [ngClass]="{'applyRightBorder': pickedLayerName !== undefined}" class="layerPicker">
            <div class="center header">
                <h6 style="margin-top: 3px; margin-right: 5px;">{{selText.select}} </h6>
                <mat-icon style="color: #4e8ecc;" matTooltip="{{selText.layer}}">layers</mat-icon>

            </div>
            <mat-list id="chooseLayerList" *ngIf="layerHamburgerMenuActive === false; else hamburger">
                <div *ngIf="userLayers !== undefined">
                    <mat-list-item *ngFor="let layer of (userLayers | userLayerFilter)" matTooltip="{{layer.table}}">
                        <!--(response.layers | userLayerFilter)-->
                        <button mat-menu-item #layerButton class="layersButtons" (click)="layerPicked(layer, $event.target)">
                            {{layer.table}}
                        </button>
                        <mat-icon style="color: #D93636; cursor: pointer;" class="btnHoover" matTooltip="Delete"
                            (click)="handleDeleteInit(layer.table)">delete_outline</mat-icon>
                    </mat-list-item>

                </div>
            </mat-list>

            <!-- Hamburger Menu -->
            <ng-template #hamburger>
                <div class="center" (click)="toggleHamburgerMenu()" style="cursor: pointer; height: 40px;">
                    <mat-icon id="hamburgerForLayerPicker">menu</mat-icon>
                </div>
            </ng-template>

        </section>
        <section *ngIf="pickedLayerName !== undefined" id="layerCard"> <!-- *ngIf = "pickedLayerName !== undefined" -->

            <form [formGroup]="layerForm" #megaForm *ngIf="loadingLogoIsHidden === true">

                <div class="header center" style="width: 90%;">
                    <mat-icon matTooltip="{{selText.optionLabelText}}">settings</mat-icon>
                    <mat-icon matTooltip="{{selText.for}}">keyboard_arrow_right</mat-icon>
                    <mat-icon style="color: #4e8ecc;" matTooltip="{{selText.layer}}">layers</mat-icon>
                    <mat-icon matTooltip="{{selText.layerName}}">keyboard_arrow_right</mat-icon>
                    <h6 style="margin-top: 2px;">{{pickedLayerName}}</h6>
                </div>

                <!-- Layer name -->
                <mat-form-field class="inputField" appearance="outline">
                    <mat-label>Title - Icelandic: </mat-label>
                    <input type="text" matInput formControlName="is" placeholder="{{pickedLayerName}}" />
                    <mat-hint>Title of the layer in Icelandic</mat-hint>
                </mat-form-field>

                <!-- Layer name -->
                <mat-form-field class="inputField" appearance="outline">
                    <mat-label>Title - English: </mat-label>
                    <input type="text" matInput formControlName="en" placeholder="{{pickedLayerName}}" />
                    <mat-hint>Title of the layer in English</mat-hint>
                </mat-form-field>

                <!-- attributions -->
                <mat-form-field class="inputField" appearance="outline">
                    <mat-label>Attributions: </mat-label>
                    <input type="text" matInput formControlName="attributions" placeholder="" />
                    <mat-hint>Define attributions</mat-hint>
                </mat-form-field>

                <!-- attributions -->
                <mat-form-field class="inputField" appearance="outline">
                    <mat-label>Metadata: </mat-label>
                    <input type="text" matInput formControlName="metadata" placeholder="" />
                    <mat-hint>Link to metadata</mat-hint>
                </mat-form-field>

                <!-- Birta (disabled) -->
                <mat-form-field class="inputField" appearance="fill">
                    <mat-label>Show Layer: </mat-label>
                    <mat-select formControlName="checked">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                    <mat-hint>Show layer immediately</mat-hint>
                </mat-form-field>

                <div class="slider">
                    <!-- TODO: The 'tickInterval' property no longer exists -->
                    <mat-slider #ngSlider><input matSliderThumb #layerOpacitySlider
                            (change)="setLayerOpacityValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})"
                            #ngSliderThumb="matSliderThumb" [(value)]="opacity" /></mat-slider>
                    <!--div class = "opacityPreview" style = "opacity: {{layerOpacitySlider.value / 100}}"></!--div-->
                    <div class="opacityPreview" [style.opacity]="layerOpacitySlider.value / 100"></div>
                    <span style="margin-left: 10px; color: rgba(0,0,0,.8);">{{layerOpacitySlider.value}}%</span>
                    <span style="margin-left: 15px; margin-top: -5px; color: rgba(0,0,0,.6); font-size: 12px;">Opacity
                        of whole layer</span>
                </div>

                <div class="header spaced">
                    <div class="header center">
                        <mat-icon matTooltip="{{selText.optionLabelText}}">settings</mat-icon>
                        <mat-icon matTooltip="{{selText.for}}">keyboard_arrow_right</mat-icon>
                        <mat-icon style="color: #4e8ecc;" matTooltip="{{selText.style}}">palette</mat-icon>
                        <mat-icon matTooltip="{{selText.geomType}}">keyboard_arrow_right</mat-icon>
                        <h6>{{pickedLayerGeomType}}</h6>
                    </div>
                </div>

                <!-- Style configuration -->
                <mat-form-field class="inputField" appearance="fill" style="margin-bottom: 20px;">
                    <mat-label>Select Style: </mat-label>
                    <mat-select formControlName="stylesToPick">
                        <mat-option value="newStyle" (click)="resetStyleSectionOnNewStyle(layerForm?.get('stylesToPick')?.value)">New
                            style</mat-option>
                        <mat-option value=""
                            (click)="resetStyleSectionOnNewStyle(layerForm?.get('stylesToPick')?.value)">Default</mat-option>

                        <div *ngIf="userStyles !== undefined">
                            <div *ngFor="let style of stylesForLayerGeomType">
                                <mat-option value="{{style.name}}"
                                    (click)="parseCSS(style); resetStyleSectionOnNewStyle(layerForm?.get('stylesToPick')?.value)">{{style.name}}</mat-option>
                            </div>
                        </div>
                    </mat-select>
                    <mat-hint>Select style. If defualt then a default style will be used</mat-hint>
                </mat-form-field>

                <div formGroupName="style" *ngIf="layerForm?.get('stylesToPick')?.value !== ''" style="display: contents">

                    <mat-form-field *ngIf="layerForm?.get('stylesToPick')?.value === 'newStyle'" class="inputField" appearance="outline">
                        <mat-label>Style Name: </mat-label>
                        <input type="text" matInput formControlName="styleName" placeholder="" />
                        <mat-hint>Unique name for this style</mat-hint>
                        <mat-error *ngIf="layerForm?.get('style.styleName')?.invalid">
                            You must enter a unique name
                        </mat-error>
                    </mat-form-field>

                    <!-- Symbol type for point -->
                    <mat-form-field *ngIf="pickedLayerGeomType === 'point'" class="inputField" appearance="fill">
                        <mat-label>Symbol Type: </mat-label>
                        <mat-select formControlName="symbol">
                            <mat-option value="circle">Circle</mat-option>
                            <mat-option value="square">Square</mat-option>
                            <mat-option value="triangle">Triangle</mat-option>
                            <mat-option value="star">Star</mat-option>
                            <mat-option value="cross">Cross</mat-option>
                            <mat-option value="x">x</mat-option>
                        </mat-select>
                        <mat-hint>Pick symbol type</mat-hint>
                        <mat-error *ngIf="layerForm?.get('style.symbol')?.invalid">
                            Picking a symbol is required
                        </mat-error>-
                    </mat-form-field>

                    <mat-form-field *ngIf="pickedLayerGeomType === 'point'" class="inputField" appearance="outline">
                        <mat-label>Symbol Size: </mat-label>
                        <input type="number" matInput formControlName="symbolSize" />
                        <mat-hint>In pixels</mat-hint>
                        <mat-error *ngIf="layerForm?.get('style.symbolSize')?.invalid">
                            Specifying a symbol size is required
                        </mat-error>
                    </mat-form-field>

                    <div *ngIf="pickedLayerGeomType === 'point' || 
                                                                         pickedLayerGeomType === 'polygon'" class="slider">
                        <!-- TODO: The 'tickInterval' property no longer exists -->
                        <mat-slider #ngSlider><input matSliderThumb #fillOpacitySlider
                                (change)="setFillOpacityValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})"
                                #ngSliderThumb="matSliderThumb" [(value)]="fillOpacity" /></mat-slider>
                        <!--div class = "opacityPreview" style = "opacity: {{fillOpacitySlider.value / 100}}"></!--div-->
                        <div class="opacityPreview" [style.opacity]="fillOpacitySlider.value / 100"></div>
                        <span style="margin-left: 10px; color: rgba(0,0,0,.8);">{{fillOpacitySlider.value}}%</span>
                        <span style="margin-left: 15px; margin-top: -5px; color: rgba(0,0,0,.6); font-size: 12px;">Opacity
                            of the fill</span>
                    </div>

                    <mat-form-field *ngIf="pickedLayerGeomType === 'point' || 
                                            pickedLayerGeomType === 'line' || 
                                            pickedLayerGeomType === 'polygon'" class="inputField" appearance="outline">
                        <mat-label>Stroke Size: </mat-label>
                        <input type="number" matInput formControlName="strokeSize" />
                        <mat-hint>In pixels</mat-hint>
                        <mat-error *ngIf="layerForm?.get('style.strokeSize')?.invalid">
                            Specifying stroke size is required
                        </mat-error>
                    </mat-form-field>


                    <div id="dashArrayInput" *ngIf="pickedLayerGeomType === 'line'">

                        <mat-form-field class="inputField" appearance="outline">
                            <mat-label>Draw: </mat-label>
                            <input type="number" matInput formControlName="dashVisible" />
                            <mat-hint>In pixels</mat-hint>
                        </mat-form-field>
                        <h3 style="margin-top: 15px;">-</h3>
                        <mat-form-field *ngIf="pickedLayerGeomType === 'line'" class="inputField" appearance="outline">
                            <mat-label>Invisible: </mat-label>
                            <input type="number" matInput formControlName="dashInvisible" />
                            <mat-hint>In pixels</mat-hint>
                        </mat-form-field>
                        <span style="color: rgba(0,0,0,.6); font-size: 12px;">Dashed Line</span>
                    </div>

                </div>

                <button mat-raised-button type="button" class="btnHoover" id="submitButton" (click)="handleSubmit()">Submit</button>
            </form>
        </section>
    </div>